// app/javascript/controllers/validity_period_toggler_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["periodFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    // 選択されたラジオボタンを取得
    const selectedType = this.element.querySelector('input[name*="validity_period_type"]:checked').value;
    
    // 'no_expiration' が選択されているかどうか
    const isNoExpiration = selectedType === 'no_expiration';

    // 期間入力フィールドの表示/非表示を切り替え
    this.periodFieldsTarget.style.display = isNoExpiration ? 'none' : 'block';
    
    // 期間入力フィールド内の required 属性を制御 (HTML5バリデーション用)
    this.periodFieldsTarget.querySelectorAll('input, select').forEach(field => {
      if (isNoExpiration) {
        field.removeAttribute('required');
      } else {
        field.setAttribute('required', 'required');
      }
    });
  }
}